import ScheduledEventsRepository from './scheduled_events_repository'
import EventTagsRepository from './event_tags_repository'
import LatestArchivedEvents from './latest_archived_events'
import EventArchiveSectionsRepository from './event_archive_sections_repository'

const repositories = {
  scheduled_events: ScheduledEventsRepository,
  event_tags: EventTagsRepository,
  latest_archived_events: LatestArchivedEvents,
  event_archive_sections: EventArchiveSectionsRepository
}

export const RepositoryFactory = {
  get: name => repositories[name]
}
